import axios from "axios"
import {Eexam, EexamMeta} from "../types"

export const loadEexamMeta = async (authHeader: object): Promise<EexamMeta> => {
    const response = await axios.get<EexamMeta>("/api/eexam/meta", authHeader)
    return response.data
}

export const loadEexams = async (authHeader: object): Promise<Eexam[]> => {
    const response = await axios.get<Eexam[]>("/api/eexam/eexams", authHeader)
    return response.data
}

export const saveEexam = async (data: Partial<Eexam>, authHeader: object): Promise<Eexam> => {
    if (data._id) {
        const response = await axios.put<Eexam>(`/api/eexam/eexams/${data._id}`, data, authHeader)
        return response.data
    }

    const response = await axios.post<Eexam>("/api/eexam/eexams", data, authHeader)
    return response.data
}

export const deleteEexam = async (id: string, authHeader: object): Promise<void> => {
    await axios.delete(`/api/eexam/eexams/${id}`, authHeader)
}
